export const descData = [
    {
        key: "value",
        type: "props",
        parameterType: "",
        desc: "ip地址",
        remark: "v-model绑定的值",
    },
    {
        key: "@change",
        type: "method",
        parameterType: "",
        desc: "",
        remark: "改变值时触发",
    },
    {
        key: "@input",
        type: "method",
        parameterType: "",
        desc: "",
        remark: "输入值时触发",
    }
]
